import { IInternalNote } from '@sdk/contracts';
import { Divider, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  DateWrapper,
  DescriptionWrapper,
  DetailWrapper,
  FooterWrapper,
  InfoWrapper,
  TitleWrapper,
  Wrapper
} from './InternalNoteCard.styles';

import { Icon } from '@/components/Icon';
import { InternalNoteTypeTag } from '@/components/InternalNotes';
import { useInternalNotesForm } from '@/hooks';
import { getInternalNotesDateString } from '@/utils';

type Props = {
  note: IInternalNote;
  isSelected?: boolean;
};

const ICON_SIZE = 16;

export const InternalNoteCard: React.FC<Props> = ({ note, isSelected = false }) => {
  const { t } = useTranslation('ChatTranslations');
  const { openDrawer } = useInternalNotesForm();

  const { type, createdAt, title, content, highlightedBy, isForManagers } = note;

  const handleSelectNote = () => openDrawer(note);

  return (
    <>
      <Wrapper
        $highlighted={highlightedBy?._id}
        $isCardSelected={isSelected}
        onClick={handleSelectNote}>
        {highlightedBy && (
          <DetailWrapper>
            <Icon i="StarFilled" color="green6" />
            <div>{t('HIGHLIGHTED_BY', { name: note.highlightedBy?.name })}</div>
          </DetailWrapper>
        )}
        <InfoWrapper>
          <TitleWrapper>{title}</TitleWrapper>
          {content && <DescriptionWrapper dangerouslySetInnerHTML={{ __html: content }} />}
        </InfoWrapper>
        <FooterWrapper>
          <DetailWrapper>
            {type && <InternalNoteTypeTag type={type} />}
            <DateWrapper>{getInternalNotesDateString(createdAt, t)}</DateWrapper>
          </DetailWrapper>
          {isForManagers && (
            <Tooltip title={t('ONLY_FOR_MANAGERS')}>
              <div>
                <Icon i="Locked" size={ICON_SIZE} />
              </div>
            </Tooltip>
          )}
        </FooterWrapper>
      </Wrapper>
      <Divider />
    </>
  );
};
